import { FC } from 'react';
import { ContentCard, ContentCardProps, UiLibrary } from 'learning-panel-components';
import styles from './customGrid.module.scss';

interface ContentWrapperTypes {
    data: ContentCardProps[];
    xsGrid: UiLibrary.GridSize;
}

const CustomGrid: FC<ContentWrapperTypes> = ({ data, xsGrid }) => {
    return (
        <div className={styles['contents-wrapper']}>
            <UiLibrary.Grid
                container
                direction="row"
                alignItems="flex-start"
                justifyContent="flex-start"
                spacing={0}
                className={styles.grid}
            >
                {data.map((card: ContentCardProps, index: number) => (
                    <UiLibrary.Grid item xs={xsGrid} key={index} style={{ display: 'flex', justifyContent: 'center' }}>
                        <ContentCard {...card} />
                    </UiLibrary.Grid>
                ))}
            </UiLibrary.Grid>
        </div>
    );
};

export default CustomGrid;
